@if (commissioner; as commissioner) {
    <cll-dialog-layout>
        <cll-dialog-header>
            <cll-dialog-title>Working hours</cll-dialog-title>
            <cll-dialog-subtitle>Configure the working hours for {{ commissioner.name }}</cll-dialog-subtitle>
        </cll-dialog-header>
        <div class="dialog-detail">
            <form [formGroup]="workingHoursFormGroup">
                <div *ngFor="let workingHourFormGroup of workingHoursFormArray.controls; let i = index"
                     [formGroup]="workingHourFormGroup">

                    <div class="working-hour-row">
                        <div class="working-hour-field">
                            <span class="working-hour-weekday">
                                {{ workingHourFormGroup.get('weekday')?.value }}
                            </span>
                        </div>
                        <div>
                            <cll-checkbox formControlName="open" />
                        </div>
                        <div class="working-hour-times">
                            @if (workingHourFormGroup.get('open')?.value) {
                                <cll-form-field label="Start time">
                                    <input cllFormInput formControlName="start_time" type="time">
                                </cll-form-field>
                                <span class="to-center">to</span>
                                <cll-form-field label="End time">
                                    <input cllFormInput formControlName="end_time" type="time">
                                </cll-form-field>
                            }
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <span class="dialog-divider"></span>
        <div class="special-hours-container-title">
            <cll-icon type="outlined" [size]="24">schedule</cll-icon>
            <span>Special hours</span>
        </div>
        <div class="special-hours-detail">
            <span
                class="special-hours-hint">Add any special hours that may occur, e.g. bank holidays, closures, etc</span>

            <form [formGroup]="specialHoursFormGroup">
                <div *ngFor="let specialHourFormGroup of specialHoursFormArray.controls; let i = index"
                     [formGroup]="specialHourFormGroup">

                    <div class="special-hour-container">
                        <div class="special-hour-header">
                            <cll-form-field label="Name" class="name-field">
                                <input cllFormInput formControlName="name" type="text">
                            </cll-form-field>
                        </div>

                        <div class="special-hour-row">
                            <div class="date-column">
                                <cll-form-field label="Date">
                                    <input cllFormInput formControlName="date" type="date">
                                </cll-form-field>
                            </div>

                            <div class="status-time-column">
                                <div class="form-field-wrapper">
                                    <div class="checkbox-label-container">
                                        <cll-checkbox formControlName="open" />
                                        <span class="working-hour-weekday">
                                            {{ specialHourFormGroup.get('open')?.value ? 'Active' : 'Inactive' }}
                                        </span>
                                    </div>
                                </div>

                                @if (specialHourFormGroup.get('open')?.value) {
                                    <div class="special-hour-times">
                                        <cll-form-field label="Start Time">
                                            <input cllFormInput formControlName="start_time" type="time">
                                        </cll-form-field>
                                        <span class="to-center">to</span>
                                        <cll-form-field label="End Time">
                                            <input cllFormInput formControlName="end_time" type="time">
                                        </cll-form-field>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <button cll-outline-button class="add-button" (click)="addSpecialHour()">
                    <cll-icon cllButtonIcon>add</cll-icon>
                    Add
                </button>
            </form>
        </div>
        <span class="dialog-divider"></span>
        <cll-dialog-footer>
            <button cll-button colour="variant" cllDialogClose>
                Cancel
            </button>
            <button cll-filled-button colour="secondary" (click)="update()"
                    [disabled]="saving">
                Save
            </button>
        </cll-dialog-footer>
    </cll-dialog-layout>
}
